var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.564 13.558a1.505 1.505 0 000-2.12 1.506 1.506 0 00-2.12 0L23.002 23.883l-7.943-7.942a1.506 1.506 0 00-2.12 0L2.437 26.442a1.506 1.506 0 000 2.12 1.506 1.506 0 002.12 0l9.442-9.443 7.943 7.942a1.506 1.506 0 002.12 0l13.503-13.503z"
  })));
}
export default SvgLine;